var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3952 7.10053C44.7857 7.49105 44.7857 8.12422 44.3952 8.51474L38.0313 14.8787C37.6407 15.2692 37.0076 15.2692 36.617 14.8787C36.2265 14.4882 36.2265 13.855 36.617 13.4645L42.2739 7.80763L36.617 2.15078C36.2265 1.76026 36.2265 1.12709 36.617 0.736566C37.0076 0.346042 37.6407 0.346042 38.0313 0.736566L44.3952 7.10053ZM43.6881 8.80763C24.461 8.80763 16.8988 8.42749 0.797337 8.80736L0.750164 6.80791C16.8767 6.42745 24.539 6.80763 43.6881 6.80763V8.80763Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrow);
export default __webpack_public_path__ + "static/media/line_arrow.6f3415b9dafcf62741b910e971d03ffb.svg";
export { ForwardRef as ReactComponent };